export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  GUEST = 'ROLE_GUEST',
  // PAID_USER = 'ROLE_PAID_USER',
  PRO_USER = 'ROLE_PAID_PRO',
  ULTRA_USER = 'ROLE_PAID_ULTRA',
}

export const USER_KEY_HEADER = 'x-user-key';
